import { h } from 'preact'

/**
 * ChannelCard — reusable card used by HomeScreen for the AI / Guide / Email
 * entry points. `variant` drives the icon background (gradient for AI,
 * solid purple circle for guide/email — see plan "Design" section).
 *
 * Props: { icon, iconVariant: 'gradient'|'solid', title, subtitle, onClick, index }
 * `index` drives the staggered card-rise entrance animation delay.
 */
export function ChannelCard({ icon, iconVariant = 'solid', title, subtitle, onClick, index = 0 }) {
  return (
    <button
      type="button"
      class="beacon-channel-card"
      style={`--beacon-card-delay: ${index * 70}ms`}
      onClick={onClick}
    >
      <span class={`beacon-channel-icon beacon-channel-icon-${iconVariant}`}>
        <i class={`bi ${icon}`}></i>
      </span>
      <span class="beacon-channel-text">
        <span class="beacon-channel-title">{title}</span>
        <span class="beacon-channel-subtitle">{subtitle}</span>
      </span>
      <i class="bi bi-chevron-right beacon-channel-chevron"></i>
    </button>
  )
}
